module.exports = __webpack_public_path__ + "static/media/front-right.33f8785c.svg";